module.exports = __webpack_public_path__ + "static/paypal-logo-c384388381c465eef06df50cd130f646.svg";